var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-1",
    clipPath: "url(#clip0_1003_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0C7.1625 0 0 7.1625 0 16C0 24.8375 7.1625 32 16 32C24.8375 32 32 24.8375 32 16C32 7.1625 24.8375 0 16 0ZM16 30C8.28125 30 2 23.7188 2 16C2 8.28125 8.28125 2 16 2C23.7188 2 30 8.28125 30 16C30 23.7188 23.7188 30 16 30ZM20 22H17V9C17 8.63087 16.7969 8.29313 16.4717 8.11938C16.1484 7.94363 15.7529 7.96312 15.4454 8.16821L12.4454 10.1682C11.9875 10.475 11.8625 11.0938 12.1687 11.5562C12.4734 12.0152 13.0938 12.1382 13.5556 11.8336L15 10.8687V22H12C11.4473 22 11 22.4473 11 23C11 23.5527 11.45 24 12 24H20C20.5527 24 21 23.5527 21 23C21 22.4473 20.55 22 20 22Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_1649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.77eed6d043fcd8a9909e55d75cc54444.svg";
export { ForwardRef as ReactComponent };